module.exports = __webpack_public_path__ + "static/media/Promotion_Card_CN.250b08d5.png";